import { render } from "./AlchemyPictureSelect.vue?vue&type=template&id=5482dc5e&scoped=true"
import script from "./AlchemyPictureSelect.vue?vue&type=script&lang=js"
export * from "./AlchemyPictureSelect.vue?vue&type=script&lang=js"

import "./AlchemyPictureSelect.vue?vue&type=style&index=0&id=5482dc5e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5482dc5e"]])

export default __exports__